// оплаты заказов договоров аутов
import React, { useEffect, useState } from "react";
import Loader from 'components/Common/Loader';
import { Table, Input } from 'antd';

// Zustand store
import { useShallow } from 'zustand/react/shallow';
import { useContractOrdersStore } from 'storeZustand';
import { useOrderPaymentsColumns, useSearch, useOrderPaymentsFilters, usePaymentTypeOrders } from 'hooks';
import { DangerBtn, SecondaryBtn } from 'components';
import SelectExternalCompany from './selectExternalCompany';
import CustomRadio from 'components/Common/CustomRadio';

const ContractOrderPayments = () => {
	const { Search } = Input;
	const [contractOrderId, setContractOrderId] = useState(null);
	const { applyFilters } = useOrderPaymentsFilters(); // применить фильтры заказов
	// Тип оплаты как параметр фильтрации
	const { paymentType, setPaymentType, paymentTypeOptions, handlePaymentTypeChange } = usePaymentTypeOrders();

	// колонки в таблице заказов
	const columns = useOrderPaymentsColumns();

	// Заказы
	const [
		loading,
		orderFilters,
		addOrderFilter,
		resetFilters,
		contractOrderPayments,
		getOrderPayments
	] = useContractOrdersStore(useShallow((state) => [
		state.loading,
		state.orderFilters,
		state.addOrderFilter,
		state.resetFilters,
		state.contractOrderPayments,
		state.getOrderPayments
	]));

	useEffect(() => {
		getOrderPayments();
	}, []);

	// Сброс поля ввода id заказа для фильтрации
	useEffect(() => {
		if (Object.keys(orderFilters).length === 0) {
			setContractOrderId(null);
			setPaymentType(null);
			getOrderPayments();
		}
	}, [orderFilters]);

	// глобальный поиск в таблице
	const { onSearch, filteredSearchData } = useSearch(contractOrderPayments);

	// функция сохранения id заказа из инпута
	const handleContractOrderIdChange = (e) => {
		const value = e.target.value;
		setContractOrderId(value);
		addOrderFilter({ contract_order_id: value });
	}

	return (
		<>
			<div className="d-flex gap-1 mb-2">
				<Search
					placeholder="Поиск в таблице"
					allowClear
					onSearch={onSearch}
					style={{
						width: 220,
					}}
					enterButton
				/>
				{/* Поле ввода id заказа для фильтрации */}
				<Input
					type='number'
					value={contractOrderId}
					placeholder="ID заказа"
					onChange={handleContractOrderIdChange}
					style={{ width: 85 }}
				/>
				<div style={{ width: 200 }}>
					{/* Выбор внешней компании */}
					<SelectExternalCompany />
				</div>
				{/* Нал или безнал */}
				<CustomRadio
					value={paymentType}
					onChange={handlePaymentTypeChange}
					options={paymentTypeOptions}
				/>
				<SecondaryBtn onClick={applyFilters}>Применить</SecondaryBtn>
				<DangerBtn onClick={resetFilters}>Сбросить</DangerBtn>
			</div>

			{loading && <Loader />}
			{!loading && filteredSearchData && filteredSearchData?.length > 0 && (
				<Table
					columns={columns}
					dataSource={filteredSearchData}
					pagination={false}
					size='small'
					rowKey="id"
				/>
			)}
		</>
	)
}

export default ContractOrderPayments;